// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidenav {
  position: fixed;
  z-index: 999999;
  width: 265px;
  padding: 4px 16px;
  bottom: 0;
  top: 0;
}
.sidenav .divider {
  margin: 8px 0;
}
.sidenav .vertical-menu-wrapper {
  height: calc(100vh - 140px);
}

.options {
  position: fixed;
  width: 270px;
  z-index: 999999;
}
.options .op-header {
  height: 64px;
  padding: 0 14px;
}
.options .control {
  padding: 6px 14px;
}
.options .control div {
  padding: 6px 0;
}
.options .control h4 {
  border-bottom: 1px solid #ccc;
  margin: 12px 0 6px 0;
}
.options .control .skin-primary {
  width: 24px;
  height: 24px;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
}
.options .control .skin-primary .skin-secondary {
  width: 0;
  height: 0;
  padding: 0;
  border-bottom: 24px solid;
  border-left: 24px solid transparent;
}
.options .control .skin-primary.blue {
  background-color: #082a54;
  border: 1px solid #082a54;
}
.options .control .skin-primary.green {
  background-color: #689f38;
  border: 1px solid #689f38;
}
.options .control .skin-primary.red {
  background-color: #d32f2f;
  border: 1px solid #d32f2f;
}
.options .control .skin-primary.pink {
  background-color: #c2185b;
  border: 1px solid #c2185b;
}
.options .control .skin-primary.purple {
  background-color: #7b1fa2;
  border: 1px solid #7b1fa2;
}
.options .control .skin-primary.grey {
  background-color: #455a64;
  border: 1px solid #455a64;
}
.options .control .skin-primary.orange-dark {
  background-color: #f4511e;
  border: 1px solid #f4511e;
}
.options .control .skin-primary.orange-dark .skin-secondary {
  border-bottom-color: #303030;
}
.options .mat-mdc-radio-group {
  display: inline-flex;
  flex-direction: column;
}
.options .mat-mdc-radio-group .mat-mdc-radio-button {
  margin: 2px 0;
}
.options .mat-mdc-slide-toggle {
  height: auto;
}
.options ng-scrollbar {
  height: calc(100vh - 64px);
}

.op-image {
  box-shadow: 0 0 2px #ccc;
  border: 2px solid;
  border-color: transparent;
  cursor: pointer;
  transition: 0.2s;
}

.options-icon {
  position: fixed;
  top: 200px;
  right: 0;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  cursor: pointer;
  z-index: 99999;
}
.options-icon .mat-icon {
  animation: spin 8s linear infinite;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
.back-to-top {
  position: fixed;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 999999;
  right: 20px;
  bottom: 20px;
  opacity: 0.5;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.75);
  border-radius: 50%;
  transition: 0.3s;
}
.back-to-top:hover {
  opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/app/components/pages/page-container/page-container.component.scss","webpack://./src/app/theme/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,eAAA;EACA,YCMmB;EDLnB,iBAAA;EACA,SAAA;EACA,MAAA;AADF;AAGE;EACE,aAAA;AADJ;AAIE;EACE,2BAAA;AAFJ;;AAMA;EACE,eAAA;EACA,YAAA;EACA,eAAA;AAHF;AAKE;EACE,YAAA;EACA,eAAA;AAHJ;AAME;EACE,iBAAA;AAJJ;AAMI;EACE,cAAA;AAJN;AAOI;EACE,6BAAA;EACA,oBAAA;AALN;AAQI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AANN;AAQM;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,mCAAA;AANR;AASM;EACE,yBAAA;EACA,yBAAA;AAPR;AAUM;EACE,yBAAA;EACA,yBAAA;AARR;AAWM;EACE,yBAAA;EACA,yBAAA;AATR;AAYM;EACE,yBAAA;EACA,yBAAA;AAVR;AAaM;EACE,yBAAA;EACA,yBAAA;AAXR;AAcM;EACE,yBAAA;EACA,yBAAA;AAZR;AAeM;EACE,yBAAA;EACA,yBAAA;AAbR;AAeQ;EACE,4BAAA;AAbV;AAmBE;EACE,oBAAA;EACA,sBAAA;AAjBJ;AAmBI;EACE,aAAA;AAjBN;AAqBE;EACE,YAAA;AAnBJ;AAsBE;EACE,0BAAA;AApBJ;;AAwBA;EACE,wBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AArBF;AAuBE;EAGE,kCAAA;AArBJ;AAqCA;EACE;IACE,yBAAA;EAxBF;AACF;AA2BA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;AAzBF;AA2BE;EACE,YAAA;AAzBJ","sourcesContent":["@import \"../../../theme/styles/variables\";\r\n\r\n.sidenav {\r\n  position: fixed;\r\n  z-index: 999999;\r\n  width: $main-sidenav-width;\r\n  padding: 4px 16px;\r\n  bottom: 0;\r\n  top: 0;\r\n\r\n  .divider {\r\n    margin: 8px 0;\r\n  }\r\n\r\n  .vertical-menu-wrapper {\r\n    height: calc(100vh - 140px);\r\n  }\r\n}\r\n\r\n.options {\r\n  position: fixed;\r\n  width: 270px;\r\n  z-index: 999999;\r\n\r\n  .op-header {\r\n    height: 64px;\r\n    padding: 0 14px;\r\n  }\r\n\r\n  .control {\r\n    padding: 6px 14px;\r\n\r\n    div {\r\n      padding: 6px 0;\r\n    }\r\n\r\n    h4 {\r\n      border-bottom: 1px solid #ccc;\r\n      margin: 12px 0 6px 0;\r\n    }\r\n\r\n    .skin-primary {\r\n      width: 24px;\r\n      height: 24px;\r\n      padding: 0;\r\n      overflow: hidden;\r\n      cursor: pointer;\r\n\r\n      .skin-secondary {\r\n        width: 0;\r\n        height: 0;\r\n        padding: 0;\r\n        border-bottom: 24px solid;\r\n        border-left: 24px solid transparent;\r\n      }\r\n\r\n      &.blue {\r\n        background-color: #082a54;\r\n        border: 1px solid #082a54;\r\n      }\r\n\r\n      &.green {\r\n        background-color: #689f38;\r\n        border: 1px solid #689f38;\r\n      }\r\n\r\n      &.red {\r\n        background-color: #d32f2f;\r\n        border: 1px solid #d32f2f;\r\n      }\r\n\r\n      &.pink {\r\n        background-color: #c2185b;\r\n        border: 1px solid #c2185b;\r\n      }\r\n\r\n      &.purple {\r\n        background-color: #7b1fa2;\r\n        border: 1px solid #7b1fa2;\r\n      }\r\n\r\n      &.grey {\r\n        background-color: #455a64;\r\n        border: 1px solid #455a64;\r\n      }\r\n\r\n      &.orange-dark {\r\n        background-color: #f4511e;\r\n        border: 1px solid #f4511e;\r\n\r\n        .skin-secondary {\r\n          border-bottom-color: #303030;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .mat-mdc-radio-group {\r\n    display: inline-flex;\r\n    flex-direction: column;\r\n\r\n    .mat-mdc-radio-button {\r\n      margin: 2px 0;\r\n    }\r\n  }\r\n\r\n  .mat-mdc-slide-toggle {\r\n    height: auto;\r\n  }\r\n\r\n  ng-scrollbar {\r\n    height: calc(100vh - 64px);\r\n  }\r\n}\r\n\r\n.op-image {\r\n  box-shadow: 0 0 2px #ccc;\r\n  border: 2px solid;\r\n  border-color: transparent;\r\n  cursor: pointer;\r\n  transition: 0.2s;\r\n}\r\n\r\n.options-icon {\r\n  position: fixed;\r\n  top: 200px;\r\n  right: 0;\r\n  width: 40px;\r\n  height: 40px;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  color: #fff;\r\n  cursor: pointer;\r\n  z-index: 99999;\r\n\r\n  .mat-icon {\r\n    -webkit-animation: spin 8s linear infinite;\r\n    -moz-animation: spin 8s linear infinite;\r\n    animation: spin 8s linear infinite;\r\n  }\r\n}\r\n\r\n@-moz-keyframes spin {\r\n  100% {\r\n    -moz-transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes spin {\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.back-to-top {\r\n  position: fixed;\r\n  width: 40px;\r\n  height: 40px;\r\n  cursor: pointer;\r\n  z-index: 999999;\r\n  right: 20px;\r\n  bottom: 20px;\r\n  opacity: 0.5;\r\n  color: #fff;\r\n  background-color: rgba(0, 0, 0, 0.75);\r\n  border-radius: 50%;\r\n  transition: 0.3s;\r\n\r\n  &:hover {\r\n    opacity: 0.9;\r\n  }\r\n}","$font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n$theme-max-width: 1300px;\r\n$top-toolbar-height: 36px;\r\n$main-toolbar-height: 72px;\r\n$user-menu-width: 220px;\r\n$header-image-min-height: 320px;\r\n$header-video-min-height: 360px;\r\n$header-carousel-height: 460px;\r\n$header-map-height: 550px;\r\n$main-content-header-offset-to-top: 80px;\r\n\r\n$main-sidenav-width: 265px;\r\n$search-sidenav-width: 288px;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
